function checkURL() {
  if (window.location.pathname === '/account/login') {
    window.scrollTo(0, 0);
  }
}

// Проверка при загрузке страницы
checkURL();

// Обработчик на изменение URL через popstate или hashchange
window.addEventListener('popstate', checkURL);
window.addEventListener('hashchange', checkURL);

// Проверка при изменении URL через History API
// Проверка при изменении URL через History API
if (!window._historyPatched) {
  window._historyPatched = true;
  const originalPushState = history.pushState;
  history.pushState = function (...args) {
    originalPushState.apply(this, args);
    checkURL();
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    checkURL();
  };
}

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

$(document).ready(() => {
  const version = "1.0.0"
  let plateFlag = false;
  // Check version and clear selectedCar if version changed
  const storedVersion = localStorage.getItem('version');
  if (storedVersion !== version) {
    // Version changed or doesn't exist, clear selectedCar and update version
    localStorage.removeItem('selectedCar');
    localStorage.setItem('version', version);
  }

  // Инициализация кнопки - заблокирована по умолчанию
  $('.main-banner__button button').prop('disabled', true);

  let $targetBlock = $('.pdp-big-description__content');
  let originalHeight = $targetBlock.outerHeight();
  let newHeight = (originalHeight / 2) + 100;
  // $targetBlock.css('max-height', newHeight + 'px');

  let currentURL = window.location.href;

  if (window.location.hash === '#recover' || window.location.hash === '#login') {
    window.scrollTo(0, 0);
  }

  const $productBlock = $(".m-main-product");

  if ($productBlock.length > 0) {
    const productId = $productBlock.data("product-id");

    if (productId) {
      // HTML для прелоудера
      // Функция для скрытия прелоудера в конкретном контейнере
      function hidePreloader($container) {
        $container.find(".preloader").hide();
      }

      // Функция для показа прелоудера в конкретном контейнере
      function showPreloader($container) {
        $container.find(".preloader").show();
      }

      // Функция для создания и добавления прелоудера в контейнер
      function addPreloader($container) {
        const preloadHtml = `
    <div class="preloader">
      <div class="spinner"></div>
    </div>
  `;
        $container.append(preloadHtml);
      }

      // 1-й AJAX запрос (по клику на таб analog)
      const handleAnalogTabClick = (event) => {
        const tab = event.target.closest('.product-big-description__tab[data-analog]');
        if (!tab) return;
        
        document.removeEventListener('click', handleAnalogTabClick);
        
        const analogContainer = document.querySelector('.pdp-big-description__analog');
        if (!analogContainer) {
          console.warn("Контейнер .pdp-big-description__analog не найден.");
          return;
        }

        const $analogContainer = $(analogContainer); // Оставляем для функций прелоудера

        addPreloader($analogContainer);
        showPreloader($analogContainer);

        const url = `${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/product/${productId}/analog`;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
          })
          .then((data) => {
            if (Array.isArray(data) && data.length > 0) {
              const htmlContent = data.map(item => {
                const brand = item.product.vendor || "No brand";
                const code = item.product.title || "No code";
                const quantity = item.product.totalInventory || 1;
                const price = item.product.variants?.edges?.[0]?.node?.price || "0.00";
                const variantId = item.product.variants?.edges?.[0]?.node?.id || "";

                return `
                  <div class="pdp-analog-item">
                    <div class="input-col">${brand}</div>
                    <div class="input-col">
                      <a href="/products/${item.product.handle}">${code}</a>
                    </div>
                    <div class="input-col">${quantity}</div>
                    <div class="input-col">€ ${price}</div>
                    <div class="input-col m-product-form">
                      <button class="m-add-to-cart" data-variant-id="${variantId}">LISÄÄ OSTOSKORIIN</button>
                    </div>
                  </div>
                `;
              }).join('');

              analogContainer.insertAdjacentHTML('beforeend', htmlContent);

              // Делегирование событий для кнопок добавления в корзину
              analogContainer.addEventListener('click', (cartEvent) => {
                const button = cartEvent.target.closest('.m-add-to-cart');
                if (!button) return;

                const variantId = button.dataset.variantId;
                if (!variantId) return;

                button.disabled = true;

                const formData = {
                  items: [{
                    id: variantId,
                    quantity: 1
                  }]
                };

                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(formData)
                })
                  .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                  })
                  .then(() => {
                    const cartDrawer = document.querySelector('m-cart-drawer');
                    if (cartDrawer) {
                      cartDrawer.onCartDrawerUpdate();
                      cartDrawer.open();
                    }
                  })
                  .catch(error => {
                    console.error('Error adding product to cart:', error);
                    alert('Error adding product to cart. Please try again.');
                  })
                  .finally(() => {
                    button.disabled = false;
                  });
              });
            } else {
              analogContainer.insertAdjacentHTML('beforeend', '<p>Vastaavia ei löytynyt.</p>');
            }
          })
          .catch(error => {
            console.error("Ошибка при запросе:", error);
            analogContainer.insertAdjacentHTML('beforeend', '<p>Virhe 500 – Palvelinvirhe.</p>');
          })
          .finally(() => {
            hidePreloader($analogContainer);
          });
      };

      document.addEventListener('click', handleAnalogTabClick);

      // 2-й AJAX запрос (по клику на таб table)
      const handleTableTabClick = (event) => {
        const tab = event.target.closest('.product-big-description__tab[data-table]');
        if (!tab) return;
        
        document.removeEventListener('click', handleTableTabClick);

        const fitmentContainer = document.querySelector('.fitment');
        if (!fitmentContainer) return;

        const $fitmentContainer = $(fitmentContainer); // Оставляем для функций прелоудера

        addPreloader($fitmentContainer);
        showPreloader($fitmentContainer);

        const supplier = tab.dataset.supplier;
        const url = supplier
          ? `https://app.menvaraosat.fi/api/oz-parts/product/vehicles?productId=${productId}`
          : `${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/product/${productId}/vehicles`;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
          })
          .then((data) => {
            if (Array.isArray(data) && data.length > 0) {
              const fallback = 'Ei tietoja';
              const seenRows = new Set();

              const htmlContent = data.reduce((html, item) => {
                const brand = item.manufName || fallback;
                const model = item.modelName || fallback;
                const years = item.yearsOfConstruction || item.carDesc || fallback;
                const isEmptyRow = brand === fallback && model === fallback && years === fallback;

                const rowKey = isEmptyRow ? 'empty' : `${brand}|${model}|${years}`;
                if (seenRows.has(rowKey)) return html;
                seenRows.add(rowKey);

                if (isEmptyRow) {
                  return html + `
                    <div class="pdp-vehicles-item">
                      <div class="input-col">${fallback}</div>
                    </div>
                  `;
                }

                return html + `
                  <div class="pdp-vehicles-item">
                    <div class="input-col">${brand}</div>
                    <div class="input-col">${model}</div>
                    <div class="input-col">${years}</div>
                  </div>
                `;
              }, '');

              fitmentContainer.insertAdjacentHTML('beforeend', htmlContent);
            } else {
              fitmentContainer.insertAdjacentHTML('beforeend', '<p>Vastaavia ei löytynyt.</p>');
            }
          })
          .catch(error => {
            console.error("Request error:", error);
            const fitmentParent = document.querySelector('.fitment-container');
            if (fitmentParent) {
              fitmentParent.insertAdjacentHTML('beforeend', '<p>Virhe 500 – Palvelinvirhe.</p>');
            } else {
              fitmentContainer.insertAdjacentHTML('beforeend', '<p>Virhe 500 – Palvelinvirhe.</p>');
            }
          })
          .finally(() => {
            hidePreloader($fitmentContainer);
          });
      };

      document.addEventListener('click', handleTableTabClick);


      // 3-й AJAX запрос (по клику на таб)

      const handleOriginalTabClick = (event) => {
        const tab = event.target.closest('.product-big-description__tab[data-original]');
        if (!tab) return;

        document.removeEventListener('click', handleOriginalTabClick);
        console.log('Original parts tab clicked. Fetching data for productId:', productId);
        
        const originalContainer = document.querySelector('.pdp-big-description__original-container');
        if (!originalContainer) return;
        
        const $originalContainer = $(originalContainer);

        console.log('Sending request to original-numbers...');
        addPreloader($originalContainer);
        showPreloader($originalContainer);

        const apiUrl = `${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/product/${productId}/original-numbers`;

        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            console.log('Original numbers data received:', data);

            if (Array.isArray(data) && data.length > 0) {
              data.sort((a, b) => {
                if (a.brand < b.brand) return -1;
                if (a.brand > b.brand) return 1;
                if (a.originalNumber < b.originalNumber) return -1;
                if (a.originalNumber > b.originalNumber) return 1;
                return 0;
              });

              const htmlContent = data.map((item) => {
                const { brand, originalNumber } = item;
                const link = item.shopifyProduct?.id.replace('gid://shopify/Product/', '');

                if (link) {
                  return `
                    <div class="pdp-original-item">
                      <div class="input-col">${brand}</div>
                      <div class="input-col">
                        <a class="pdp-original__link" href="/product/${link}">${originalNumber}</a>
                      </div>
                    </div>
                  `;
                }

                return `
                  <div class="pdp-original-item">
                    <div class="input-col">${brand}</div>
                    <div class="input-col">
                      <span class="pdp-original__link">${originalNumber}</span>
                    </div>
                  </div>
                `;
              }).join('');

              const pdpOriginalHeader = document.querySelector('.pdp-original-header');
              if (pdpOriginalHeader) {
                pdpOriginalHeader.style.display = 'flex';
              }
              
              originalContainer.insertAdjacentHTML('beforeend', htmlContent);
            } else {
              originalContainer.insertAdjacentHTML('beforeend', '<p>Vastaavia ei löytynyt.</p>');
            }

            const pdpOriginal = document.querySelector('.pdp-big-description__original');
            if (pdpOriginal && !originalContainer.querySelector('.pdp-original-item')) {
              pdpOriginal.insertAdjacentHTML('beforeend', 'Ei alkuperäisiä osia.');
            }
          })
          .catch((error) => {
            console.error("Request error:", error);
            const pdpOriginal = document.querySelector('.pdp-big-description__original');
            if (pdpOriginal) {
              pdpOriginal.insertAdjacentHTML('beforeend', '<p>Virhe 500 – Palvelinvirhe.</p>');
            }
          })
          .finally(() => {
            console.log('Original numbers request completed.');
            hidePreloader($originalContainer);
          });
      };

      document.addEventListener('click', handleOriginalTabClick);

      const savedCar = JSON.parse(localStorage.getItem('selectedCar'));
      if (savedCar && savedCar.carId) {
        $.ajax({
          url: `${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/product/${productId}/check-vehicle-${savedCar.carId}`,
          method: "GET",
          dataType: "json",
          beforeSend: function () {
            const $fitmentContainer = $(".fitment");
            addPreloader($fitmentContainer);
            showPreloader($fitmentContainer);
            addPreloader($('.cm-verify-fitment-loader'));
            showPreloader($('.cm-verify-fitment-loader'));
          },
          success: function (data) {
            if (data && data.vehicle !== undefined) {
              const isCompatible = data.vehicle;

              $('.cm_verify-fitment_title').text(
                isCompatible ? 'Osa sopii autollesi' : 'Osa ei sovi autollesi'
              );

              $('.cm_verify-fitment_notes').text(
                isCompatible
                  ? 'Tämä osa on yhteensopiva valitsemasi auton kanssa'
                  : 'Tämä osa ei ole yhteensopiva valitsemasi auton kanssa'
              );

              $('.cm_icon-questionmark').remove();

              if (isCompatible) {
                $('.cm_verify-fitment_icon').html(`<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 28 28" fill="#fff"><path style="fill: #fff" d="M6.65263 14.0304C6.29251 13.6703 6.29251 13.0864 6.65263 12.7263C7.01276 12.3662 7.59663 12.3662 7.95676 12.7263L11.6602 16.4297L19.438 8.65183C19.7981 8.29171 20.382 8.29171 20.7421 8.65183C21.1023 9.01195 21.1023 9.59583 20.7421 9.95596L12.3667 18.3314C11.9762 18.7219 11.343 18.7219 10.9525 18.3314L6.65263 14.0304Z" fill="#000000"/><path clip-rule="evenodd" d="M14 1C6.8203 1 1 6.8203 1 14C1 21.1797 6.8203 27 14 27C21.1797 27 27 21.1797 27 14C27 6.8203 21.1797 1 14 1ZM3 14C3 7.92487 7.92487 3 14 3C20.0751 3 25 7.92487 25 14C25 20.0751 20.0751 25 14 25C7.92487 25 3 20.0751 3 14Z" fill="#FFF" fill-rule="evenodd"/></svg>`);
                $('.cm_vehicle-widget').css('background', '#11A637')
              } else {
                $('.cm_verify-fitment_icon').html(`<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="32px" height="32px" viewBox="0 0 32 32"><path d="M18.8,16l5.5-5.5c0.8-0.8,0.8-2,0-2.8l0,0C24,7.3,23.5,7,23,7c-0.5,0-1,0.2-1.4,0.6L16,13.2l-5.5-5.5c-0.8-0.8-2.1-0.8-2.8,0C7.3,8,7,8.5,7,9.1s0.2,1,0.6,1.4l5.5,5.5l-5.5,5.5C7.3,21.9,7,22.4,7,23c0,0.5,0.2,1,0.6,1.4C8,24.8,8.5,25,9,25c0.5,0,1-0.2,1.4-0.6l5.5-5.5l5.5,5.5c0.8,0.8,2.1,0.8,2.8,0c0.8-0.8,0.8-2.1,0-2.8L18.8,16z"/></svg>`);
              }
            }
          },
          error: function (xhr, status, error) {
            console.error(error);
          },
          complete: function () {
            const $compatibilityContainer = $(".product-compatibility-check");
            if ($compatibilityContainer.length) {
              hidePreloader($compatibilityContainer);
            }

            hidePreloader($('.cm-verify-fitment-loader'));
            $('.cm-verify-fitment-loader').hide()
          }
        });
      } else {
        hidePreloader($('.cm-verify-fitment-loader'));
        $('.cm-verify-fitment-loader').hide()
      }

    }
  }
  const savedCar = JSON.parse(localStorage.getItem('selectedCar'));

  if (savedCar && savedCar.isPlate) {
    $('.banner-plate-info__dropdown').remove()
    $('.banner-plate-info__dropdown-toggle').remove()
    $('.banner-form').hide()
    $('.main-banner__button button').prop('disabled', false);
    $('.banner-plate-info-js').empty()
    $('.banner-plate-info-js').append(savedCar.carName)
    $('.banner-plate-info').append(carInfoTemplate(savedCar))
    $('.banner-plate-info').show()
    $('.main-banner__button a').show();
    $('.car-plate-js').val(savedCar.plateNumber)
  }

  $('.metafields__content').each(function () {
    const $content = $(this);
    const hasDivs = $content.children('.pdp-description-row').length > 0;

    if (!hasDivs) {
      $content.text('Ei tietoja.');
    }

  });

  $('.m-reset-password-btn,.m-recover-form__cancel-btn').click(function (event) {
    window.scrollTo(0, 0);
  });

  $('.dropdown-toggle').click(function () {
    $('.dropdown-menu').toggle();
  });

  const tabs = document.querySelectorAll('.product-big-description__tab');
  const sectionsMap = {
    'table': document.querySelector('.pdp-big-description__table'),
    'desc': document.querySelector('.pdp-big-description__content'),
    'analog': document.querySelector('.pdp-big-description__analog'),
    'original': document.querySelector('.pdp-big-description__original')
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Убираем активный класс у всех табов и добавляем текущему
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      // Ищем ключ, соответствующий data-атрибуту кликнутого таба
      const targetKey = Object.keys(sectionsMap).find(key => this.hasAttribute(`data-${key}`));

      // Показываем нужную секцию, остальные скрываем
      Object.entries(sectionsMap).forEach(([key, section]) => {
        if (section) {
          section.style.display = (key === targetKey) ? 'block' : 'none';
        }
      });
    });
  });

  setTimeout(() => {
    var itemsPerPage = 20;
    var $rows = $('.fitment-table-body .fitment-row');
    var totalItemsRows = $rows.length;
    var totalPages = Math.ceil(totalItemsRows / itemsPerPage);

    function showPage(page) {
      $rows.hide();
      var start = (page - 1) * itemsPerPage;
      var end = start + itemsPerPage;
      $rows.slice(start, end).show();
      $(`#pagination .pagination-btn[data-page=${page}]`).addClass('active')
    }

    for (var i = 1; i <= totalPages; i++) {
      $('#pagination').append('<button class="pagination-btn" data-page="' + i + '">' + i + '</button>');
    }

    $('#pagination').on('click', '.pagination-btn', function () {
      $(`#pagination .pagination-btn`).removeClass('active')
      let page = $(this).data('page');
      showPage(page);
    });

    showPage(1);
  }, 1500)


  $('.accordion-header').on('click', function () {
    let $item = $(this).closest('.accordion-item');

    $item.toggleClass('active');
    $item.find('.accordion-content').slideToggle();
  });

  $('.accordion-item:first').addClass('active').find('.accordion-content').show();

  if (currentURL.includes('order')) {
    $('.m-account__content').hide()
    $('.m-order__content').show()

    $('.nav-account').removeClass('active')
    $('.nav-order').addClass('active')
  }

  if (currentURL.includes('/pages/wishlist')) {
    $('.nav-account').removeClass('active')
    $('.m-account__navigation-wrap a').removeClass('active')
    $('.m-account__navigation-wrap a:last-child').addClass('active')
  }


  $('.m-collapsible--button').on('click', function () {
    $('.m-faqs-section__block-accordion').removeClass('highlight')
    $('.m-collapsible--button span').css('color', '#20232d')

    let parentBlock = $(this).closest('.m-faqs-section__block-accordion');

    if ($(this).parent('.m-collapsible').attr('open')) {
      parentBlock.addClass('highlight');
      $(this).find('span').css('color', '#f85a00')
    } else {
      parentBlock.removeClass('highlight');
      $(this).find('span').css('color', '#20232d')
    }
  });

  $('.main-banner__slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
  })
  $('.section-blog__slider').slick({
    infinite: true,
    slidesToShow: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  var $status = $('.product-with__header-slides');
  var $slickElement = $('.product-with__slider');

  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);
  });

  $slickElement.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    prevArrow: $('.product-with__header-prev'),
    nextArrow: $('.product-with__header-next')
  })

  $('.js-car-brand,.js-car-model,.js-car-engine').on('change', function () {
    if ($(this).val()) {
      $(this).addClass('selected')
    } else {
      $(this).removeClass('selected')
    }
  });


  let brandItems = $('.brand-item');
  let itemsPerRow = 4;
  let totalItems = brandItems.length;
  let lastRowCount = totalItems % itemsPerRow;

  if (lastRowCount > 0 || totalItems > 0) {
    let startIndex = totalItems - lastRowCount;
    if (lastRowCount === 0) {
      startIndex = totalItems - itemsPerRow;
    }


    for (let i = startIndex; i < totalItems; i++) {
      let wrapper = $(brandItems[i]).find('.brand-item__wrapper');
      wrapper.css('border-bottom', 'none');
      $(brandItems[i]).css('padding-bottom', '12px')
    }
  }

  $('.js-car-model').select2({
    placeholder: "Valitse malli",
    width: '100%',
    language: {
      noResults: function () {
        return "Ei tuloksia";
      }
    }
  });

  $('.js-car-engine').select2({
    placeholder: "Valitse moottori",
    width: '100%',
    language: {
      noResults: function () {
        return "Ei tuloksia";
      }
    }
  });

  $('.js-car-brand').select2({
    placeholder: "Valitse merkki",
    width: '100%',
    language: {
      noResults: function () {
        return "Ei tuloksia";
      }
    }
  });

  // Ensure Select2 search field is visible on mobile when dropdown opens
  // Fixes: mobile keyboard overlapping the dropdown and search in banner-form
  (function () {
    const isMobile = () => window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

    // Use a delegated handler to work across dynamic re-initializations
    $(document).on('select2:open', function (e) {
      const $target = $(e.target);
      if (!$target.is('.js-auto-brands')) return;
      if (!isMobile()) return;

      // Wait a tick so Select2 renders the dropdown and search input
      setTimeout(function () {
        const searchInput = document.querySelector('.select2-container--open .select2-search__field');
        if (searchInput) {
          try { searchInput.focus({ preventScroll: false }); } catch (_) { /* noop */ }
          // Scroll the search field into the center of the viewport
          searchInput.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
          // Nudge a bit upward to account for fixed headers/toolbars
          setTimeout(function () { window.scrollBy(0, -20); }, 200);
        } else {
          // Fallback: scroll the form itself into view
          const form = document.querySelector('.banner-form');
          if (form) form.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, 100);
    });
  })();

  // Function to fetch and store vehicle manufacturers
  function fetchVehicleManufacturers() {
    return fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/vehicle/manufactures`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Clear existing options first
        $('.js-car-brand').empty();
        $('.js-car-brand').append('<option value=""></option>');

        for (let i in data.array) {
          const temp = `<option value="${data.array[i].manuId}">${data.array[i].manuName}</option>`;
          $('.js-car-brand').append(temp);
        }

        // Remove duplicates
        removeDuplicateOptions('.js-car-brand');

        // Initialize Select2
        $('.js-car-brand').select2({
          placeholder: "Valitse merkki",
          width: '100%',
          language: {
            noResults: function () {
              return "Ei tuloksia";
            }
          }
        });

        return data; // Return data for chaining
      })
      .catch(error => {
        console.error("Error fetching vehicle manufacturers:", error);
        throw error; // Re-throw for proper error handling
      });
  }

  // Function to remove duplicate options from select elements
  function removeDuplicateOptions(selector) {
    const $select = $(selector);
    const seen = new Set();
    const $options = $select.find('option');

    $options.each(function () {
      const value = $(this).val();
      const text = $(this).text();
      const key = value + '|' + text;

      if (seen.has(key)) {
        $(this).remove();
      } else {
        seen.add(key);
      }
    });
  }

  // Function to clear all select elements
  function clearAllSelects() {
    $('.js-car-brand').empty().append('<option value=""></option>');
    $('.js-car-model').empty().append('<option value=""></option>');
    $('.js-car-engine').empty().append('<option value=""></option>');
  }

  let selectedBrand

  $('.js-car-brand').on("change", function (e) {
    selectedBrand = $(this).select2('data');
    if (!selectedBrand || !selectedBrand[0] || !selectedBrand[0].id) {
      return;
    }
    $('.js-car-model').empty();

    $('.js-car-engine').empty();
    $('.js-car-model').append('<option value=""></option>');
    $('.js-car-model').prop('disabled', false);


    fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/vehicle/manufactures/${selectedBrand[0].id}/models`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Add manufacturers to select
        $('.js-car-model').select2('destroy')

        for (let i in data.array) {
          const temp = `<option value="${data.array[i].modelId}">${data.array[i].modelname} </option>`;
          $('.js-car-model').append(temp);
        }

        // Remove duplicates
        removeDuplicateOptions('.js-car-model');

        // Initialize Select2
        $('.js-car-model').select2({
          placeholder: "Valitse malli",
          width: '100%',
          language: {
            noResults: function () {
              return "Ei tuloksia";
            }
          }
        });
      })
      .catch(error => {
        console.error("Error fetching vehicle manufacturers:", error);
      });
  });

  let vehicles

  $('.js-car-model').on('change', function () {
    const selectedData = $(this).select2('data');
    if (!selectedBrand || !selectedBrand[0] || !selectedBrand[0].id || !selectedData || !selectedData[0] || !selectedData[0].id) {
      return;
    }

    $('.js-car-engine').prop('disabled', false);

    $('.js-car-engine').empty();
    $('.js-car-engine').append('<option value=""></option>');
    fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/vehicle/manufactures/${selectedBrand[0].id}/models/${selectedData[0].id}/vehicles`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        vehicles = data;
        $('.js-car-engine').select2('destroy');

        for (let i in data) {
          const temp = `<option value="${data[i].carId}">${data[i].motorCodes !== "" ? data[i].motorCodes.array[0].motorCode : ""} (${data[i].vehicleDetails.typeName}) ${data[i].vehicleDetails.powerHpTo}HP</option>`;
          $('.js-car-engine').append(temp);
        }

        // Remove duplicates
        removeDuplicateOptions('.js-car-engine');

        $('.js-car-engine').select2({
          placeholder: "Valitse moottori",
          width: '100%',
          language: {
            noResults: function () {
              return "Ei tuloksia";
            }
          }
        });
      })
      .catch(error => {
        console.error("Error fetching vehicle manufacturers:", error);
      });
  })

  function saveSelectedCar(car) {
    if (localStorage.getItem('selectedCar')) {
      localStorage.removeItem('selectedCar');

    }
    localStorage.setItem('selectedCar', car);
  }

  // const savedCar = JSON.parse(localStorage.getItem('selectedCar'));

  const isSearchPage = window.location.pathname.includes('/pages/search');
  if ($('.main-banner_engine').length > 0 && !isSearchPage) {
  // Блокируем кнопку, если нет сохранённой машины
  if (!savedCar) {
    // $('.main-banner__button button').prop('disabled', true);
  } else {
    $('.main-banner__button button').prop('disabled', false);
  }

  if (savedCar && savedCar.vehicleDetails && savedCar.vehicleDetails.manuId && savedCar.vehicleDetails.modId) {
    // Load full data for brand select
    fetchVehicleManufacturers().then(() => {
      // Set the saved brand as selected
      $('.js-car-brand').val(savedCar.vehicleDetails.manuId).trigger('change');

      // Load models for the saved brand
      fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/vehicle/manufactures/${savedCar.vehicleDetails.manuId}/models`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          $('.js-car-model').select2('destroy');

          for (let i in data.array) {
            const temp = `<option value="${data.array[i].modelId}">${data.array[i].modelname} </option>`;
            $('.js-car-model').append(temp);
          }

          // Remove duplicates
          removeDuplicateOptions('.js-car-model');

          $('.js-car-model').select2({
            placeholder: "Valitse malli",
            width: '100%',
            language: {
              noResults: function () {
                return "Ei tuloksia";
              }
            }
          });

          // Set the saved model as selected
          $('.js-car-model').val(savedCar.vehicleDetails.modId).trigger('change');

          // Load vehicles for the saved model using the saved car's modId
          fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/vehicle/manufactures/${savedCar.vehicleDetails.manuId}/models/${savedCar.vehicleDetails.modId}/vehicles`, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            }
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              vehicles = data;
              $('.js-car-engine').select2('destroy');

              for (let i in data) {
                const temp = `<option value="${data[i].carId}">${data[i].motorCodes !== "" ? data[i].motorCodes.array[0].motorCode : ""} (${data[i].vehicleDetails.typeName}) ${data[i].vehicleDetails.powerHpTo}HP</option>`;
                $('.js-car-engine').append(temp);
              }

              // Remove duplicates
              removeDuplicateOptions('.js-car-engine');

              $('.js-car-engine').select2({
                placeholder: "Valitse moottori",
                width: '100%',
                language: {
                  noResults: function () {
                    return "Ei tuloksia";
                  }
                }
              });

              // Set the saved engine as selected
              $('.js-car-engine').val(savedCar.carId).trigger('change');
            })
            .catch(error => {
              console.error("Error fetching vehicles:", error);
            });
        })
        .catch(error => {
          console.error("Error fetching models:", error);
        });
    });

    // Show reset button when car is selected
    $('.main-banner__button a').show();
  } else {

    // Hide reset button when no car is selected
    $('.main-banner__button a').hide();

    fetchVehicleManufacturers();
  }
  }
  // Fetch manufacturers data
  $('.input-clear').hide()

  $('.header-search__wrapper input').on('input', function () {
    if ($(this).val().length > 0) {
      $('.input-clear').show()
    } else {
      $('.input-clear').hide()
    }
  })
  $('.input-clear').on('click', function () {
    $(this).prev().val('')
    $('.header-search__dropdown')
      .removeClass('active')
      .css('display', 'none')
      .css('opacity', '0')
      .css('visibility', 'hidden');
    $('.header-search__dropdown-wrapper').empty();
    $('.input-clear').hide()
  })

  let car

  $('.main-banner__button button').on('click', function () {
    if (!plateFlag) {
      car = $('.js-car-engine').select2('data')
      for (let i in vehicles) {
        if (vehicles[i].carId === parseInt(car[0].id)) {
          const selectedCar = vehicles[i]
          saveSelectedCar(JSON.stringify(selectedCar))

          $('.main-banner__button button').prop('disabled', false);
        }
      }
    }
  })

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Autocomplete function
  const handleAutocomplete = debounce(function (query) {
    if (query.length > 2) {
      // Clear previous results
      $('.header-search__dropdown-wrapper').empty();

      fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/autocomplete`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
          query: query
        })
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          for (let i in data) {
            let imgClasses = ' image-block--svg';
            let image = '<svg class="icon icon-no-image-sm"><use href="#no-image-sm"></use></svg>';
            if (data[i].imgs && data[i].imgs[1]) {
              imgClasses = ' image-block--img';
              image = `<img src="${data[i].imgs[1]}" alt="Image of ${data[i].title}">`;
            }
            $('.header-search__dropdown-wrapper').append(`
          <a href="/products/${data[i].handle}" class="cmTemplate_product item product-item nav-item" tabindex="-1">
            <div class="image-block${imgClasses}">${image}</div>
            <div class="description-block">
              <div class="title">${data[i].title}</div>
              <div class="price">
                € ${data[i].price}
              </div>
            </div>
          </a>
          `)
          }
          $('.header-search__dropdown')
            .addClass('active')
            .css('display', 'block')
            .css('opacity', '1')
            .css('visibility', 'visible');
        })
        .catch(error => {
          console.error('Error fetching autocomplete:', error);
        });
    }
  }, 300); // 300ms delay

  $('.header-search__wrapper input').on("input", function () {
    const query = $(this).val().trim();
    if (query.length > 2) {
      handleAutocomplete(query);
      $('.header-search__dropdown')
        .addClass('active')
        .css('display', 'block')
        .css('opacity', '1')
        .css('visibility', 'visible');
    } else {
      $('.header-search__dropdown')
        .removeClass('active')
        .css('display', 'none')
        .css('opacity', '0')
        .css('visibility', 'hidden');
      $('.header-search__dropdown-wrapper').empty();
    }
  });

  // Handle Enter key press
  $('.header-search__wrapper input').on('keypress', function (e) {
    if (e.which === 13) { // 13 is Enter key
      e.preventDefault();
      const query = $(this).val().trim();
      if (query.length > 0) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    }
  });

  $('.main-banner__button button').on('click', function () {
    const url = new URL(window.location.href);

    if (window.location.pathname === `/pages/search`) {
      if (url.searchParams.has("genericArticleId")) {
        url.searchParams.delete("genericArticleId");

        window.history.replaceState({}, "", url);
      }
      window.location.reload()
    } else {
      window.location.href = `/pages/search`;
    }
  })

  // Add click handler for reset button
  $('.main-banner__button a').on('click', function (e) {
    const $dropdown = $(".banner-plate-info__dropdown");
    const isVisible = $dropdown.is(':visible');

    e.preventDefault();

    // Clear localStorage
    localStorage.removeItem('selectedCar');

    if (isVisible && (window.location.pathname !== `/pages/search` && (window.location.pathname !== `/en/pages/search`))) {
      $('html, body').animate({
        scrollTop: $('.main-banner__search-wrapper').offset().top - 100
      }, 50, 'swing');
    }
    // Clear all selects
    clearAllSelects();

    // Re-fetch manufacturers to ensure clean data
    fetchVehicleManufacturers().then(() => {

    }).catch(error => {
      console.error('Error reloading manufacturers:', error);
    });



    // Reload page to ensure clean state
    window.location.reload();
  });

  // Handle dropdown visibility
  $(document).on('click', function (e) {
    const $target = $(e.target);
    const $searchWrapper = $('.header-search__wrapper');
    const $dropdown = $('.header-search__dropdown');

    if ($target.closest($searchWrapper).length) {
      if ($searchWrapper.find('input').val().trim().length > 2) {
        $dropdown
          .addClass('active')
          .css('display', 'block')
          .css('opacity', '1')
          .css('visibility', 'visible');
      }
    } else {
      $dropdown
        .removeClass('active')
        .css('display', 'none')
        .css('opacity', '0')
        .css('visibility', 'hidden');
    }
  });

  // Clear dropdown when input is empty
  $('.header-search__wrapper input').on("input", function () {
    if ($(this).val().trim().length === 0) {
      $('.header-search__dropdown').removeClass('active');
      $('.header-search__dropdown-wrapper').empty();
    }
  });

  // Функция для проверки всех селектов и блокировки/разблокировки кнопки
  function checkCarSelectsAndToggleButton() {
    const savedCar = JSON.parse(localStorage.getItem('selectedCar'));
    if (savedCar) {
      $('.main-banner__button button').prop('disabled', false);
      return;
    }
    const brand = $('.js-car-brand').val();
    const model = $('.js-car-model').val();
    const engine = $('.js-car-engine').val();
    const brandEnabled = !$('.js-car-brand').prop('disabled');
    const modelEnabled = !$('.js-car-model').prop('disabled');
    const engineEnabled = !$('.js-car-engine').prop('disabled');

    // Проверяем, что js-car-engine выбран и не заблокирован
    if (engine && engineEnabled) {
      $('.main-banner__button button').prop('disabled', false);
    } else {
      $('.main-banner__button button').prop('disabled', true);
    }
  }

  // Событие для обычных и Select2 селектов
  $('.js-car-brand, .js-car-model, .js-car-engine').on('change.select2 change', checkCarSelectsAndToggleButton);

  // Вызвать при загрузке страницы и после инициализации селектов
  $(document).ready(function () {
    // Remove any existing duplicates
    removeDuplicateOptions('.js-car-brand');
    removeDuplicateOptions('.js-car-model');
    removeDuplicateOptions('.js-car-engine');

    checkCarSelectsAndToggleButton();
  });

  $('.car-plate-button-js').on('click', function () {
    searchByCarPlate()
  });

  $('.car-plate-js').on("keydown", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      searchByCarPlate()
    }
  })

  $('.banner-plate-remove').on('click', function () {
    localStorage.removeItem('selectedCar');
    window.location.reload()
  })


  // Обработчик для toggle dropdown с информацией о машине
  $(document).on('click', '.banner-plate-info__dropdown-toggle', function (e) {
    e.preventDefault();
    const $dropdown = $(".banner-plate-info__dropdown");
    const isVisible = $dropdown.is(':visible');

    $dropdown.slideToggle(400, function () {
      // Если dropdown был открыт и теперь закрывается, скроллим к search wrapper
      if (isVisible && (window.location.pathname !== `/pages/search` && (window.location.pathname !== `/en/pages/search`))) {
        $('html, body').animate({
          scrollTop: $('.main-banner__search-wrapper').offset().top - 100
        }, 600, 'swing');
      }
    });

    $(this).toggleClass('active');
  })

  function searchByCarPlate() {
    const $button = $(".car-plate-button-js");
    const carPlate = $('.car-plate-js').val().trim();
    console.log(window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app')
    // Проверяем, что введен номер автомобиля
    if (carPlate.length > 0) {
      // Показываем лоадер
      $button.prop('disabled', true);
      $button.html('<div class="spinner"></div>');

      fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/vehicle/car-plate`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
          number: carPlate
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          // Сохраняем ответ в переменную
          if (data) {
            // Адаптер для нового формата TecDoc
            if (data.vehicles && data.vehicles.length > 0) {
              const v = data.vehicles[0];
              const vi = v.vehicleInformation || {};
              const eng = (v.engine && v.engine.length > 0) ? v.engine[0] : {};
              const gb = v.gearbox || {};
              const t = (v.tyres && v.tyres.length > 0) ? v.tyres[0] : {};

              data = {
                carId: vi.ktype,
                carName: vi.fullModel || (vi.make + ' ' + vi.model),
                plateNumber: carPlate,
                isPlate: true,
                vehicleDetails: {
                  chassisNumber: vi.vin,
                  enginePower: vi.powerKW,
                  engineVolume: vi.ccm,
                  cylinders: eng.cylinders,
                  valves: eng.valvesPerCylinder,
                  registrationDate: vi.firstRegistrationDate,
                  tecDocNumber: vi.ktype,
                  driveType: vi.driveType,
                  bodyName: vi.bodyName,
                  bodyCode: "",
                  engineCode: eng.code,
                  engineType: eng.type,
                  fuel: eng.fuel,
                  gearbox: gb.type,
                  modelManufacturedFrom: vi.salesStartDate,
                  modelManufacturedTo: "",
                  frontTyre: t.frontWidth ? (t.frontWidth + '/' + t.frontRatio + ' R' + t.frontRadial) : "",
                  frontRimDimension: "",
                  rearTyre: t.rearWidth ? (t.rearWidth + '/' + t.rearRatio + ' R' + t.rearRadial) : "",
                  rearRimDimension: "",
                  manuId: vi.makeId,
                  modId: vi.modelId,
                  manuName: vi.make,
                  modelName: vi.model,
                  powerHpTo: vi.powerHP,
                  typeName: vi.fullModel
                }
              };
            } else {
              data.isPlate = true;
              data.plateNumber = carPlate;
            }

            $('.banner-plate-info__dropdown').remove()
            $('.banner-plate-info__dropdown-toggle').remove()

            localStorage.removeItem('selectedCar');
            localStorage.setItem('selectedCar', JSON.stringify(data));
            // saveSelectedCar(JSON.stringify(data))

            $('.banner-form').hide()
            // Разблокируем кнопку после успешного сохранения
            $('.main-banner__button button').prop('disabled', false);
            // Показываем кнопку сброса
            $('.banner-plate-info-js').empty()
            $('.banner-plate-info-js').append(data.carName)
            $('.banner-plate-info').append(carInfoTemplate(data))
            $('.banner-plate-info').show()
            $('.main-banner__button a').show();
            $('.main-banner__search-input__errors').hide()
            $('.main-banner__search-form').hide()
            $('.banner-plate-redirect').css('display', 'block')
            $('.banner-plate-remove').css('display', 'block')
            plateFlag = true
            $('.m-car-popup-home').hide()

          }

          // Восстанавливаем кнопку
          $button.prop('disabled', false);
          $button.html(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M9.80541 17.296C13.9423 17.296 17.2959 13.9424 17.2959 9.8055C17.2959 5.66863 13.9423 2.31503 9.80541 2.31503C5.66854 2.31503 2.31494 5.66863 2.31494 9.8055C2.31494 13.9424 5.66854 17.296 9.80541 17.296Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M15.0151 15.4043L17.9518 18.3333" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
         </svg>`);
        })
        .catch(error => {
          $('.main-banner__search-input__errors span').text('Rekisterinumero on virheellinen')
          $('.main-banner__search-input__errors').show()

          // Восстанавливаем кнопку при ошибке
          $button.prop('disabled', false);
          $button.html(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.80541 17.296C13.9423 17.296 17.2959 13.9424 17.2959 9.8055C17.2959 5.66863 13.9423 2.31503 9.80541 2.31503C5.66854 2.31503 2.31494 5.66863 2.31494 9.8055C2.31494 13.9424 5.66854 17.296 9.80541 17.296Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.0151 15.4043L17.9518 18.3333" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`);
        });
    } else {
      // Показываем сообщение, если поле пустое
      $('.main-banner__search-input__errors span').text('Anna auton rekisterikilpi')
      $('.main-banner__search-input__errors').show()
    }
  }

  function carInfoTemplate(car) {
    const formatValue = (value, suffix = '') => {
      return (value !== undefined && value !== null && value !== '') ? `${value}${suffix}` : '—';
    };
    const formatDate = (value) => {
      if (!value || value.length !== 8) return '—';
      const year = value.substring(0, 4);
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}-${month}-${day}`;
    }

    return `<div class="banner-plate-info__dropdown" style="display: none;">
                    <div class="banner-plate-info__dropdown-col">
                      <div class="banner-plate-info__dropdown-row">
                        <span>Moottori:</span>
                        <span>${formatValue(car.carName)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Rekisterinumero:</span>
                        <span>${formatValue(car.plateNumber)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>VIN-numero:</span>
                        <span>${formatValue(car.vehicleDetails.chassisNumber)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Kilowatti:</span>
                        <span>${formatValue(car.vehicleDetails.enginePower, 'kWt')}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Iskutilavuus cm³:</span>
                        <span>${formatValue(car.vehicleDetails.engineVolume)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Sylinterit:</span>
                        <span>${formatValue(car.vehicleDetails.cylinders)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Käyttöönotto:</span>
                        <span>${formatValue(formatDate(car.vehicleDetails.registrationDate))}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>TecDoc Id:</span>
                        <span>${formatValue(car.vehicleDetails.tecDocNumber)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Ajo:</span>
                        <span>${formatValue(car.vehicleDetails.driveType)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Runko:</span>
                        <span>${formatValue(car.vehicleDetails.bodyName)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Runkokoodi:</span>
                        <span>${formatValue(car.vehicleDetails.bodyCode)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Moottorikoodi:</span>
                        <span>${formatValue(car.vehicleDetails.engineCode)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Moottorityyppi:</span>
                        <span>${formatValue(car.vehicleDetails.engineType)}</span>
                      </div>
                    </div>
                    <div class="banner-plate-info__dropdown-col">
                      <div class="banner-plate-info__dropdown-row">
                        <span>Polttoainejärjestelmä:</span>
                        <span>${formatValue(car.vehicleDetails.engineType)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Polttoaine:</span>
                        <span>${formatValue(car.vehicleDetails.fuel)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Vaihdelaatikko:</span>
                        <span>${formatValue(car.vehicleDetails.gearbox)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Tuotettu alkaen:</span>
                        <span>${formatValue(formatDate(car.vehicleDetails.modelManufacturedFrom))}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Tuotettu asti:</span>
                        <span>${formatValue(formatDate(car.vehicleDetails.modelManufacturedTo))}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Etupyörät:</span>
                        <span>${formatValue(car.vehicleDetails.frontTyre)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Etuvanne:</span>
                        <span>${formatValue(car.vehicleDetails.frontRimDimension)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Takapyörät:</span>
                        <span>${formatValue(car.vehicleDetails.rearTyre)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Takavanne:</span>
                        <span>${formatValue(car.vehicleDetails.rearRimDimension)}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Pituus:</span>
                        <span>${formatValue(car.vehicleDetails.length, 'mm')}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Omamassa:</span>
                        <span>${formatValue(car.vehicleDetails.kerbWeight, 'kg')}</span>
                      </div>
                      <div class="banner-plate-info__dropdown-row">
                        <span>Auton paino:</span>
                        <span>${formatValue(car.vehicleDetails.totalWeight, 'kg')}</span>
                      </div>
                    </div>
                  </div>
                  <div class="banner-plate-info__dropdown-toggle">Ajoneuvotiedot <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.75 11.625L9.5 6.375L4.25 11.625" stroke="#F85A00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
`
  }

  MinimogTheme.Wishlist.setWishlistButtonsState()
})